import GoogleAnalytics from "../GA";

function Footer() {
    return (
        <footer className="w-full flex bg-gray-50 dark:bg-gray-800 justify-center">
            <div className="w-[1280px] flex flex-col sm:flex-row px-8 py-6 sm:px-12 sm:py-[30px] gap-4 sm:gap-0 justify-between text-gray-500 dark:text-gray-400 items-center ">
                
                <div className="sm:h-[21px] gap-1.5 text-center">
                    <p className="block text-sm font-normal ">
                        © 2024 MyNextID v1.1.0
                        <span className="mx-4">|</span>
                        <span>All rights reserved</span>
                    </p>
                </div>

                <div className="sm:h-[21px] flex gap-4 ">
                    <a href="#" className="underline text-sm font-medium" onClick={() => GoogleAnalytics("footer", "link_termsOfService", "Link to terms of service")}>Terms of service</a>
                    
                    <a href="#" className="underline text-sm font-medium" onClick={() => GoogleAnalytics("footer", "link_privacyPolicy", "Link to privacy policy")}>Privacy policy</a>
                </div>
                
            </div>
        </footer>
    );
}

export default Footer;